import { useState } from 'react'
import { Menu } from 'react-native-paper'
import { useUnistyles } from 'react-native-unistyles'

import {
  ContextMenuAction,
  ContextMenuWrapperProps,
} from '@/components/shared/ContextMenuWrapper'
import UniDivider from '@/components/unistyles/UniDivider'
import UniTouchableRipple from '@/components/unistyles/UniTouchableRipple'
import { triggerHapticClick } from '@/utils/haptics'

// eslint-disable-next-line import/prefer-default-export
export const ContextMenuWrapper = ({
  actions,
  onPress,
  children,
  style,
  wrapperKey,
}: ContextMenuWrapperProps) => {
  const { theme } = useUnistyles()
  const [menuVisible, setMenuVisible] = useState(false)
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 })

  const handleLongPress = (event: any) => {
    event.preventDefault()
    const { pageX, pageY } = event.nativeEvent
    setMenuPosition({ x: pageX, y: pageY })
    setMenuVisible(true)
    triggerHapticClick()
  }

  const closeMenu = () => setMenuVisible(false)

  const handleMenuItemPress = (handlerIndex: number) => {
    onPress(handlerIndex)
    closeMenu()
  }

  // Flatten nested actions for web display
  const flattenedActions: {
    action: ContextMenuAction
    originalIndex: number
    handlerIndex?: number // Index in the flattened handler array
    isNested?: boolean
    parentTitle?: string
  }[] = []

  let currentHandlerIndex = 0
  actions.forEach((action, index) => {
    if (action.actions) {
      // Add parent as disabled item (no handler index since it's not clickable)
      flattenedActions.push({ action, originalIndex: index })
      // Add nested actions
      action.actions.forEach((nestedAction, _nestedIndex) => {
        flattenedActions.push({
          action: nestedAction,
          originalIndex: index,
          handlerIndex: currentHandlerIndex++,
          isNested: true,
          parentTitle: action.title,
        })
      })
    } else {
      flattenedActions.push({
        action,
        originalIndex: index,
        handlerIndex: currentHandlerIndex++,
      })
    }
  })

  return (
    <>
      <UniTouchableRipple
        accessibilityRole="button"
        borderless
        key={wrapperKey}
        // @ts-expect-error - onContextMenu is not a valid prop for TouchableRipple, but it is for a div in a web context
        onContextMenu={handleLongPress}
        onLongPress={handleLongPress}
        style={style}
      >
        {children}
      </UniTouchableRipple>
      <Menu
        anchor={menuPosition}
        contentStyle={{ width: 200 }}
        onDismiss={closeMenu}
        visible={menuVisible}
      >
        {flattenedActions.map((item, index) => {
          if (item.action.actions) {
            // Parent item for nested actions - render as disabled header
            return (
              <Menu.Item
                disabled
                key={`parent-${index}`}
                // leadingIcon={item.action.systemIcon}
                title={item.action.title}
                titleStyle={{ fontWeight: 'bold' }}
              />
            )
          }

          return (
            <Menu.Item
              key={index}
              // leadingIcon={item.action.systemIcon}
              onPress={() => handleMenuItemPress(item.handlerIndex!)}
              title={
                item.isNested ? `  ${item.action.title}` : item.action.title
              }
              titleStyle={
                item.action.destructive
                  ? { color: theme.colors.error }
                  : undefined
              }
            />
          )
        })}
        {/* Add divider before destructive actions */}
        {flattenedActions.some((item) => item.action.destructive) && (
          <UniDivider />
        )}
      </Menu>
    </>
  )
}
